import React from 'react';
import { motion } from 'framer-motion';

function ProgressBar({ current, total }) {
  const percentage = (current / total) * 100;
  return (
    <div className="mb-6">
      <div className="flex justify-between text-sm mb-1 text-gray-600">
        <span>Progress</span>
        <span>{Math.round(percentage)}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <motion.div 
          className="bg-blue-600 h-2.5 rounded-full" 
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
export default ProgressBar;